import {
	createFileRoute,
	Outlet,
	redirect,
	useLocation,
} from "@tanstack/react-router";
import { AppShell } from "@/components/layout/app-shell";
import { CompleteSetupModal } from "@/components/modals/complete-setup-modal";
import { AppSidebar } from "@/components/sidebar/app-sidebar";
import { RouteErrorFallback } from "@/components/ui/route-error-fallback";
import { SubscriptionWarningBanner } from "@/features/billing/components/subscription-warning-banner";
import { ConsentGate } from "@/features/onboarding/_components/consent-gate";
import { useMe } from "@/hooks/use-me";
import { useSentryUserContext } from "@/hooks/use-sentry-user-context";
import { PDPA_CONSENT_VERSION } from "@/lib/pdpa-consent";
import { meQueryOptions, organizationsQueryOptions } from "@/lib/queries";

export const Route = createFileRoute("/(dashboard)")({
	loader: async ({ context: { queryClient } }) => {
		const organizations = await queryClient.ensureQueryData(
			organizationsQueryOptions(),
		);

		if (organizations.length === 0) {
			throw redirect({ to: "/onboarding/welcome" });
		}

		// Preload — version check is in DashboardLayout via live Convex subscription
		await queryClient.ensureQueryData(meQueryOptions());
	},
	component: DashboardLayout,
	errorComponent: RouteErrorFallback,
});

function DashboardLayout() {
	const { pathname } = useLocation();
	const me = useMe();
	useSentryUserContext();

	if (me !== undefined && me?.pdpaConsent?.version !== PDPA_CONSENT_VERSION) {
		return <ConsentGate />;
	}

	return (
		<AppShell
			sidebar={(rail) => <AppSidebar rail={rail} />}
			pathname={pathname}
		>
			<SubscriptionWarningBanner />
			<Outlet />
			<CompleteSetupModal />
		</AppShell>
	);
}
